// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getGoodsInstallationVatOptions} from '../../shared/repositories';

export const readGoodsInstallationVatOptions = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getGoodsInstallationVatOptions();

            dispatch({
                data,
                type: actions.UPDATE_CLAIM_GOODS_INSTALLATION_VAT_OPTIONS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/shared/action-creators/get-goods-installation-vat-options.js